import { observer } from "mobx-react"
import FormStore from "../../Configs/Store/forms"
import { Tooltip } from "antd"
import { UserInput } from "../QuoteScreen/QuoteAPI"
import { DataLayerFn } from "../../Configs/API"
import { ageValidation } from "../../Configs/Validator/FormValidations"
import Image from "../Common/Image"

const RadioCheck = observer(({ ConfigObj, CpName, calcForm, onToggleRadioCheck, ttParent, rootClass, imgwidth, imgheight, imgalt }) => {
  const calculateAge = async (value) => {
    var min = calcForm.getFieldValue("buyingFor") === "Child" || calcForm.getFieldValue("buyingFor") === "Grandchild" ? 0 : 18
    var max = 50
    var flag = await ageValidation(value, min, max)
    console.info("Age Validation :", flag)
    await FormStore.setCalcAge(flag.age)
    if (flag.valid && Math.sign(flag.age) !== -1) {
      calcForm.setFields([{ name: "ageItem", errors: [] }])
      window.dataLayer_dob = true
    } else if (flag.age === -1 || flag.age === -2) {
      calcForm.setFields([{ name: "ageItem", errors: [flag.errorMsg] }])
      window.dataLayer_dob = false
    }
  }

  const toggleRadioCheck = (value) => {
    FormStore.setCalcType(value)
    UserInput("calcType", value, "key", "")
    if (calcForm !== undefined) {
      var buyFor = calcForm.getFieldValue("buyingFor")
      var dobValue = FormStore.calc_dob
      console.info("Valid RadioCheck ", buyFor)
      var childFlag = FormStore.calc_age !== "" && FormStore.calc_age > 2 && FormStore.calc_age < 18
      console.info("Valid childFlag ", childFlag)
      if (value === "Retirement") {
        if (buyFor !== "Self" && buyFor !== "Spouse") {
          console.info("Retirement True")
          calcForm.setFieldsValue({
            buyingFor: "Self",
          })
          FormStore.setCalcBuyingFor("Self")
          UserInput("relation", "Self", "", "")
          calculateAge(dobValue)
        }
      } else if (value === "Child") {
        if (buyFor !== "Child" && buyFor !== "Grandchild") {
          console.info("Child True")
          calcForm.setFieldsValue({
            buyingFor: "Self",
          })
          FormStore.setCalcBuyingFor("Self")
          UserInput("relation", "Self", "", "")
          calculateAge(dobValue)
        }
      }
    }

    if (CpName === "PlanWorks") {
      DataLayerFn(`${value + "Plan_Overview"}||Calculator - Landing Page| How this plan works`, FormStore, "", value, "", "")
    } else {
      DataLayerFn(`${value + "Plan_Selected"}||Calculator - Landing Page|${value}`, FormStore, "", value, "", "")
    }
  }

  const tooltipParentSelector = () => {
    if (ttParent !== undefined) {
      return document.getElementById(`${ttParent}`)
    } else {
      return document.body
    }
  }

  if (CpName === "QuoteFunds") {
    return (
      <div className={`${CpName}_RadioTrio`}>
        {ConfigObj.map((value, index) => (
          <div key={"RadioChecks_1_" + new Date().getTime() + "_" + index} className={`${CpName}_RadioTrio_Item ${value.key === FormStore.quote_fundsTab ? "Checked" : ""}`} onClick={(e) => onToggleRadioCheck(e, value.key)}>
            <div>
              <Image
                className={`${CpName}_RadioTrio_Item_Check`}
                src={`${value.key === FormStore.quote_fundsTab ? value.bgChecked : value.bgImg}`}
                alt={value.iconAlt}
                width={imgwidth}
                height={imgheight}
              />
              <div className={`${CpName}_RadioTrio_Item_Title`}>{value.title}</div>
            </div>
          </div>
        ))}
      </div>
    )
  } else if (CpName === "QuoteInvest") {
    return (
      <div className={`${CpName}_RadioTrio ${rootClass}`}>
        {ConfigObj.filter((x) => (rootClass === "Unique" ? x.key !== "Mixed" : true)).map((value, index) => (
          <Tooltip
            key={"RadioChecks_2_" + new Date().getTime() + "_" + index}
            overlayClassName={`${CpName}_Tooltip`}
            placement="bottom"
            title={value.hoverText}
            trigger={"click"}
            getPopupContainer={tooltipParentSelector}
            open={value.key === FormStore.quote_investStrat && FormStore.quote_investStratTT && value.hoverText !== null}
            zIndex={1300}
          >
            <div className={`${CpName}_RadioTrio_Item ${value.key} ${value.key === FormStore.quote_investStrat ? "Checked" : ""}`} onClick={() => onToggleRadioCheck(value.key)}>
              <div>
                <Image
                  className={`${CpName}_RadioTrio_Item_Check`}
                  src={`${value.key === FormStore.quote_investStrat ? value.itemChecked : value.bgImg}`}
                  alt={value.key === FormStore.quote_investStrat ? "Checked Radio Icon" : "Uncheck Radio Icon"}
                  width={imgwidth}
                  height={imgheight}
                />
                <div className={`${CpName}_RadioTrio_Item_Title`}>{value.key}</div>
              </div>
            </div>
          </Tooltip>
        ))}
      </div>
    )
  } else {
    return (
      <div className={`${CpName}_RadioTrio`}>
        {ConfigObj.map((value, index) => (
          <div key={"RadioChecks_3_" + new Date().getTime() + "_" + index} className={`${CpName}_RadioTrio_Item ${value.key} ${value.key === FormStore.calc_type["key"] ? "Checked" : ""}`} onClick={() => toggleRadioCheck(value.key)}>
            <div>
              <Image
                className={`${CpName}_RadioTrio_Item_Check`}
                src={`${value.key === FormStore.calc_type["key"] ? value.itemChecked : value.bgImg}`}
                alt={value.key === FormStore.calc_type["key"] ? "Checked Radio Icon" : "Uncheck Radio Icon"}
                width={imgwidth}
                height={imgheight}
              />
              <div className={`${CpName}_RadioTrio_Item_Title`}>{value.key}</div>
            </div>
            <Image className={`${CpName}_RadioTrio_Item_Drop`} src={`${value.key === FormStore.calc_type["key"] ? value.dropSvg : ""}`} alt={""} />
          </div>
        ))}
      </div>
    )
  }
})

export default RadioCheck
